import CompoundTranslation from '@components/compound-translation';
import { RequiredMark } from '@components/required/mark';
import * as React from 'react';

interface IProps {
    requireMark?: React.ReactNode;
    /**
     * Supplies the format template of the nested interpolation.
     *
     * Available data:
     * - (0) props.children of this component
     * - (1) require mark for this component
     *
     * @default RequiredFormatTemplate.Suffix to apply the require mark as a suffix
     */
    format?: string | RequiredFormatTemplate;
}

export enum RequiredFormatTemplate {
    Prefix = '{1} {0}',
    Suffix = '{0} {1}'
}

export const RequiredWrapper: React.FunctionComponent<IProps> = props => {
    const {
        requireMark = <RequiredMark />,
        format = RequiredFormatTemplate.Suffix
    } = props;

    if (!props.children) {
        // wrapping in a Fragment due to React.FunctionComponent return type signature issue
        // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
        return (
            <React.Fragment>{requireMark}</React.Fragment>
        );
    }

    const templateInsertions = [
        props.children,
        requireMark
    ];

    return (
        <CompoundTranslation template={format}
                             data={templateInsertions}/>
    );
};



// WEBPACK FOOTER //
// ./src/components/required/index.tsx